import styled from 'styled-components'

interface IFilterDropdown {
  show?: boolean
}

export const FilterDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const FilterDropdownHeader = styled.button<IFilterDropdown>`
  all: unset;
  height: 74px;
  cursor: pointer;

  font-weight: 500;

  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .dropIcon {
    height: 16px;
    width: 16px;
    transition: rotate 0.5s;
    rotate: ${(props) => props.show && `-180deg`};
  }
  span {
    font-family: var(--font-tomorrow);
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
`

export const FilterDropdownContent = styled.div<IFilterDropdown>`
  transition: max-height 0.5s cubic-bezier(1, 0, 0, 1);
  max-height: ${(props) => (props.show ? '500px' : '0px')};
  overflow: hidden;
`
export const MyProductsFilterItemContainer = styled.div`
  padding-bottom: 24px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  input {
    background: #e8e8e8;
    border-radius: 27px;
    border: none;
    outline: none;
    height: 50px;
    width: 100%;
    padding: 0.5rem 1rem;
  }
`
